export const isSvgUrl = (url = "") => {
  return /\.(svg)($|\?)/i.test(url);
};

export const isGifUrl = (url = "") => {
  return /\.(gif)($|\?)/i.test(url);
};
